/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Impersonation/Impersonation.Forms',[], function () {
    'use strict';

    var forms = {
        customerSearch: {
            Fields: [
                {
                    "Name": 'Customer filter',
                    "Field": '#roc-impersonation-customer-filter',
                    "Param": 'customerFilter',
                    "Type": 'Text'
                }
            ],
            Validate: true
        },
        cartSearch: {
            Fields: [
                {
                    "Name": 'Shopping cart filter',
                    "Field": '#roc-impersonation-cart-filter',
                    "Param": 'cartFilter',
                    "Type": 'Text'
                }
            ],
            Validate: true
        }
    };

    return forms;
});
